<template>
  <div>
    <img class="imgs" src="../../assets/platformAnnouncementCn.png" alt="">
  </div>
</template>
<script>
export default {
  name: "App",
  components: {
  },
  data() {
    return {
    };
  },
  created() {
    document.title = '平台公告'
  },
  mounted() {
  },
  methods: {
  },
};

</script>

<style>
* {
  margin: 0;
  padding: 0;
}
</style>